import React from 'react';

import { Game }                 from '../../models/Game';
import { Recommendations as Recs } from '../../molecules/Recomendations/Recommendations';
import { equalIgnoreCase }      from '../../../utils';
import { Categories }           from '../../constants/Pages';
import styles                   from './Recommendations.css';

type RetroGamesProps = {
    allGames: Game[],
    className?: string;
};

export class RetroGames extends React.PureComponent<RetroGamesProps> {
    render() {
        const { allGames} = this.props;
        let retroGames = allGames.filter(game => game.categories.find(c => equalIgnoreCase(c, Categories.Retro)));
        if (!retroGames.length) { return null; }

        return (
            <Recommendations
                title = "Other Retro Games"
                description = "Other Retro Games"
                games = {retroGames}/>           
        );
    }
}
const Recommendations = (props: any) => <Recs className = {styles.recommendations} {...props} />;
